// Platform toast abstraction. Web/extension register sonner's toast at app
// startup (registerToastHandler(sonnerToast)); React Native registers its own
// implementation. Logic-layer modules import `toast` from here so they never
// pull DOM-only UI libraries into the bundle.
export interface ToastHandler {
  success(message: string): void;
  error(message: string): void;
  info?(message: string): void;
}

let handler: ToastHandler = {
  success: (message) => console.log('[toast]', message),
  error: (message) => console.warn('[toast]', message),
};

export const registerToastHandler = (custom: ToastHandler): void => {
  handler = custom;
};

export const toast = {
  success: (message: string): void => handler.success(message),
  error: (message: string): void => handler.error(message),
  info: (message: string): void => (handler.info ?? handler.success)(message),
};
